// extracted by mini-css-extract-plugin
module.exports = {"body":"style_body__3Qkje","content":"style_content__22UOP"};